/**
 * Returns a copy of `props` with all `undefined` values removed.
 *
 * Use this when spreading optional props onto Base UI components. Base UI
 * computes defaults for certain attributes (e.g. `aria-labelledby` is
 * auto-wired to the label sub-component's ID). Passing a prop explicitly as
 * `undefined` overwrites that default and can silently break accessibility
 * behaviour — this utility ensures only props with real values are forwarded.
 *
 * @example
 * const optionalAriaProps = filterDefinedProps({
 *   'aria-label': ariaLabel,
 *   'aria-labelledby': ariaLabelledBy,
 * });
 * // <BaseUIComponent {...optionalAriaProps} />
 */
export function filterDefinedProps<T extends Record<string, unknown>>(
  props: T
): Partial<T> {
  return Object.fromEntries(
    Object.entries(props).filter(([, value]) => value !== undefined)
  ) as Partial<T>;
}
